import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsCustomObjectTypes = "/custom_objects/custom_object_types" as const;

export const customObjectsCustomObjectTypesCacheKeys: AllRouteEndpoints[] = [customObjectsCustomObjectTypes];
